import { useSelector } from 'react-redux';

function useSelection() {
  return useSelector(({ selection }) => selection.items);
};

export default useSelection;
